// const mainDomain = "https://coretest.agriquiz.in/";
// const imageDomain = "https://coretest.agriquiz.in";

const mainDomain = "https://api.vpaedu.com/admin/";
const imageDomain = "https://api.vpaedu.com";

// const mainDomain = "http://10.127.113.5:8070/admin/";
// const imageDomain = "http://10.127.113.5:8070";

const Constants = {
  imageDomain,
  getUrls: {
    getMediaFolderList: mainDomain + "media/folder-list",
    getFolderImages: mainDomain + "media/folder-images",
    getAllLevels: mainDomain + "levels/list",
    getSingleLevel: mainDomain + "levels/details",
    getAllCourses: mainDomain + "courses/list",
    getAllCoursesDetails: mainDomain + "courses/details",
    getAllTeams: mainDomain + "teams/list",
    getTeamDetails: mainDomain + "teams/details",
    getAllSubjects: mainDomain + "subjects/list",
    getSubjectDetails: mainDomain + "subjects/details",
    getAllBatches: mainDomain + "batches/list",
    getBatchDetails: mainDomain + "batches/details",
    getAllAchievers: mainDomain + "achievers/list",
    getAchieversDetails: mainDomain + "achievers/details",
    getAllResults: mainDomain + "results/list",
    getResultDetails: mainDomain + "results/details",
    getAnnouncements: mainDomain + "announcements/list",
    getSingleAnnouncement: mainDomain + "announcements/details",
    getPopups: mainDomain + "popup/list",
    getPopupDetails: mainDomain + "popup/details",
    getAllHomeScreen: mainDomain + "home-screen/list",
    getHomeScreenDetails: mainDomain + "home-screen/details",
    getAllFaqs: mainDomain + "faqs/list",
    getFaqDetails: mainDomain + "faqs/details",
    getGalleryList: mainDomain + "gallery/list",
    getGalleryDetails: mainDomain + "gallery/details",
    getBlogList: mainDomain + "blogs/list",
    getBlogDetails: mainDomain + "blogs/details",

    // OLD APIS
    getAllTestimonials: mainDomain + "testimonial",
    getDashboard: mainDomain + "dashboard/my-dash",
    getAdminDasboard: mainDomain + "dashboard/admin-dash",
    getAllContacts: mainDomain + "contacts",
    getAllBlogs: mainDomain + "blogs/list-dash",
    getAllBlogCategories: mainDomain + "blog-categories/",
    getAllWebContacts: mainDomain + "web-contact/list-dash",
    getAllNotifications: mainDomain + "notifications/list",
    getAllAlumini: mainDomain + "alumini",
    getAllEvents: mainDomain + "event",
    getGallery: mainDomain + "gallery",
    getAllFranchiseEnquiry: mainDomain + "franchise-enquiry",
    getSocialMedia: mainDomain + "social-media",
    getSchoolEnquiry: mainDomain + "school-enquiry",
    getAllBanners: mainDomain + "banner",
    getAllExams: mainDomain + "exams/list-dash",
    getAllCounts: mainDomain + "counts",
    getAllAmenities: mainDomain + "amenities",
    getAllNavbarTexts: mainDomain + "navbartext",
    getRequestDemo: mainDomain + "demos",
  },
  postUrls: {
    createBlog: mainDomain + "blogs/create",
    createGallery: mainDomain + "gallery/create",
    createAnnouncement: mainDomain + "announcements/create",
    addNewResult: mainDomain + "results/create",
    createAchiever: mainDomain + "achievers/create",
    createBatch: mainDomain + "batches/create",
    createMediaFolder: mainDomain + "media/create-folder-images",
    addImagesToFolder: mainDomain + "media/add-images",
    createNewLevel: mainDomain + "levels/create",
    createCourses: mainDomain + "courses/create",
    createTeamsMember: mainDomain + "teams/create",
    createSubject: mainDomain + "subjects/create",
    createPopup: mainDomain + "popup/create",
    createHomeScreen: mainDomain + "home-screen/create",
    createFaq: mainDomain + "faqs/create",

    // OLD API
    createBlogCategory: mainDomain + "blog-categories/create",
    createBlogs: mainDomain + "blogs/create",
    createNewNotification: mainDomain + "notifications/create-dash",
    employerLogin: mainDomain + "auth/login",
    createTestimonial: mainDomain + "testimonial/create",
    addNewAlumini: mainDomain + "alumini/create",
    addNewEvent: mainDomain + "event/create",
    addGallery: mainDomain + "gallery",
    addNewCourse: mainDomain + "courses/create",
    addSocialMedia: mainDomain + "social-media",
    addBanner: mainDomain + "banner/create",
    sendMailFranchise: mainDomain + "franchise-enquiry/sendMail",
    createExam: mainDomain + "exams/create",
    createCount: mainDomain + "counts/create",
    createTeam: mainDomain + "teams/create",
    createAmenity: mainDomain + "amenities/create",
    createNavbarText: mainDomain + "navbartext/create",
    createAboutUs: mainDomain + "about-us/create",
  },
  putUrls: {
    updateBlog: mainDomain + "blogs/update",
    updateBlogStatus: mainDomain + "blogs/status",
    updateGallery: mainDomain + "gallery/update",
    updateGalleryStatus: mainDomain + "gallery/status",
    updateHomeScreen: mainDomain + "home-screen/update",
    changeHomeScreenStatus: mainDomain + "home-screen/status",
    updatePopup: mainDomain + "popup/update",
    changePopupStatus: mainDomain + "popup/status",
    updateAnnouncement: mainDomain + "announcements/update",
    changeAnnouncementStatus: mainDomain + "announcements/status",
    updateResult: mainDomain + "results/update",
    changeResultStatus: mainDomain + "results/status",
    updateBatch: mainDomain + "batches/update",
    changeBatchStatus: mainDomain + "batches/status",
    updateLevel: mainDomain + "levels/update",
    updateLevelStatus: mainDomain + "levels/status",
    updateCourses: mainDomain + "courses/update",
    updateCourseStatus: mainDomain + "courses/status",
    updateTeamMembers: mainDomain + "teams/update",
    changeTeamStatus: mainDomain + "teams/status",
    updateSubject: mainDomain + "subjects/update",
    changeSubjectStatus: mainDomain + "subjects/status",
    updateAchiever: mainDomain + "achievers/update",
    changeAchieversStatus: mainDomain + "achievers/status",
    updateFaq: mainDomain + "faqs/update",
    changeFaqStatus: mainDomain + "faqs/status",

    // OLD APIs
    updateAboutUs: mainDomain + "about-us/update/",
    updateBlogCategory: mainDomain + "blog-categories/update/",
    updateBlogs: mainDomain + "blogs/update/",
    updateTestimonial: mainDomain + "testimonial/update/",
    updateAlumini: mainDomain + "alumini/update/",
    updateEvent: mainDomain + "event/update/",
    updateCourses: mainDomain + "courses/update/",
    toggleCourseStatus: mainDomain + "courses/toggle-status",
    updateSocialMedia: mainDomain + "social-media",
    updateBanner: mainDomain + "banner/update",
    updateExam: mainDomain + "exams/update/",
    updateCount: mainDomain + "counts/update/",
    updateTeam: mainDomain + "teams/update/",
    updateAmenity: mainDomain + "amenities/update/",
    updateNavbarText: mainDomain + "navbartext/update/",
  },
  deleteUrls: {
      deleteBlog: mainDomain + "blogs/delete",
    deleteGallery: mainDomain + "gallery/delete",
    deleteHomeScreen: mainDomain + "home-screen/delete",
    deleteAnnouncement: mainDomain + "announcements/delete",
    deleteResult: mainDomain + "results/delete",
    deleteBatch: mainDomain + "batches/delete",
    deleteMediaFolder: mainDomain + "media/delete-folder",
    deleteImageFromFolder: mainDomain + "media/delete-images",
    deleteLevel: mainDomain + "levels/delete",
    deleteCourses: mainDomain + "courses/delete",
    deleteTeam: mainDomain + "teams/delete",
    deleteSubject: mainDomain + "subjects/delete/",
    deleteAchiever: mainDomain + "achievers/delete",
    deletePopup: mainDomain + "popup/delete/",
    deleteFaq: mainDomain + "faqs/delete/",

    //OLD API
    deleteTestimonial: mainDomain + "testimonial/delete/",
    deleteGalleryImage: mainDomain + "gallery/",
    deleteAlumini: mainDomain + "alumini/delete/",
    deleteEvent: mainDomain + "event/delete/",
    deleteBlogCategory: mainDomain + "blog-categories/delete/",
    deleteBlog: mainDomain + "blogs/delete/",
    deleteCourse: mainDomain + "courses/",
    deleteSocialMedia: mainDomain + "social-media",
    deleteSchoolEnquiry: mainDomain + "school-enquiry",
    deleteBaner: mainDomain + "banner/delete",
    deleteExam: mainDomain + "exams/delete/",
    deleteCount: mainDomain + "counts/delete/",
    deleteAmenity: mainDomain + "amenities/delete/",
    deleteNavbarText: mainDomain + "navbartext/delete/",
    deleteRequestDemo: mainDomain + "demos/delete/",
  },
};

export default Constants;
